import React from 'react';
import { CSSTransition } from 'react-transition-group';

export type TransitionProps = {
  in: boolean;
  children: any;
};

/**
 * Wraps elements in a slide down transition.
 */
export function SlideDownTransition(props: TransitionProps) {
  return (
    <CSSTransition timeout={350} classNames="slide-down" in={props.in} unmountOnExit>
      {props.children}
    </CSSTransition>
  );
}
